import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import {Button} from '@daedalus/atlas/src/components/designSystem/Button'
import {ContentWrapper} from '@daedalus/atlas/src/components/designSystem/helpers/ContentWrapper'
import {Icon} from '@daedalus/atlas/src/components/designSystem/Icon'
import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  AnalyticsContext,
  Category,
  Entity,
  Team
} from '@daedalus/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {
  getAnalyticsContext,
  getApplication,
  getError,
  getOfferEligibility
} from '../../modules/selector'
import {BookingCreation} from '../BookingCreation'
import {HotelCardWithHeaders} from '../HotelCardWithHeaders'

export const Content = () => {
  const dispatch = useDispatch()
  const {page} = useSelector(getApplication)
  const [createBookingLoading, setCreateBookingLoading] = useState(false)

  const {errored} = useSelector(getError)
  const {leadContext, offerContext, priceContext} =
    useSelector(getAnalyticsContext)
  const availableAnalyticsContexts = {
    ...(offerContext && {[AnalyticsContext.OfferContext]: offerContext}),
    ...(leadContext && {[AnalyticsContext.LeadContext]: leadContext}),
    ...(priceContext && {[AnalyticsContext.PriceContext]: priceContext})
  }

  const createFreezeBooking = () => {
    // render BookingCreation component that initiates the booking creation request
    setCreateBookingLoading(true)

    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.DealFreezeButton,
        action: Action.Clicked,
        analyticsContext: {
          ...availableAnalyticsContexts
        },
        page,
        team: Team.Select
      })
    )
  }

  const {isOfferEligible} = useSelector(getOfferEligibility)

  const isFreezable = !errored && isOfferEligible

  // Show the booking creation component when the freeze button is clicked, and the component will handle the booking creation
  if (createBookingLoading) {
    return <BookingCreation />
  }

  return (
    <ContentWrapper>
      <HotelCardWithHeaders />
      {isFreezable && (
        <>
          <Button
            variant="special"
            fullWidth
            iconEnd={<Icon name="Ice" />}
            onClick={createFreezeBooking}
            size="xl"
          >
            <FormattedMessageWrapper
              id="df.freezeOverlayButton"
              defaultMessage="Freeze price for free"
            />
          </Button>
        </>
      )}
    </ContentWrapper>
  )
}
